<router-outlet>
    <ngx-spinner bdColor="#105970"
        size="medium"
        color="#fff"
        type="line-scale">
        <p style="font-size: 20px; color: white">{{loaderText}}</p>
    </ngx-spinner>
</router-outlet>